import type { ColDef, ICellRendererParams } from "ag-grid-community";
import React from "react";
import DeleteIcon from "../../../assets/svg/bookingform/deleteIcon";

const REMOVE_COLUMN_WIDTH_PX = 64;

const removeButtonStyle: React.CSSProperties = {
  border: "none",
  background: "transparent",
  cursor: "pointer",
  padding: 6,
  margin: 0,
  lineHeight: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

type RemoveRowButtonProps = {
  rowKey: string;
  onRemove: (rowKey: string) => void;
  ariaLabel?: string;
};

const RemoveRowButton = (props: RemoveRowButtonProps) => {
  const { rowKey, onRemove, ariaLabel = "Remove from list" } = props;

  return (
    <button
      type="button"
      style={removeButtonStyle}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onRemove(rowKey);
      }}
      aria-label={ariaLabel}
    >
      <DeleteIcon style={{ margin: 0, display: "block" }} width={18} height={18} />
    </button>
  );
};

export type CreateRemoveRowColumnOptions = {
  field: string;
  onRemove: (rowKey: string) => void;
  ariaLabel?: string;
};

export const createRemoveRowColumn = (options: CreateRemoveRowColumnOptions): ColDef => {
  const { field, onRemove, ariaLabel } = options;

  return {
    colId: "remove",
    field,
    headerName: "",
    width: REMOVE_COLUMN_WIDTH_PX,
    maxWidth: REMOVE_COLUMN_WIDTH_PX,
    minWidth: REMOVE_COLUMN_WIDTH_PX,
    flex: 0,
    sortable: false,
    resizable: false,
    suppressMenu: true,
    pinned: "right",
    cellStyle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "visible",
      borderLeft: "1px solid var(--ag-border-color)",
    },
    // v28+: use cellRenderer for React; cellRendererFramework often fails to mount in modals
    cellRenderer: (params: ICellRendererParams) => {
      const rowKey = params.data?.[field] as string | undefined;
      if (!rowKey) return null;

      return <RemoveRowButton rowKey={rowKey} onRemove={onRemove} ariaLabel={ariaLabel} />;
    },
  };
};
